import createRoute           from '@widesk-ui/tools/createRoute';
import PushNotificationModel from '@models/website/PushNotificationModel';

const route = createRoute.dashboardFromModel(
	PushNotificationModel,
	'PushNotificationDashboard',
	{
		pathPrefix: '/website_entertainments/:websiteEntertainmentId',
	},
);
export default route;
